import React, { useState } from 'react';
import '../styles/BottomNavbar.css';
import { useNavigate } from 'react-router-dom';

// Импортируем SVG иконки (замените пути на ваши реальные файлы)
import TicketIcon from '../imgs/ticket.svg';
import CalendarIcon from '../imgs/calendar-star.svg';
import UserIcon from '../imgs/circle-user.svg';

const BottomNavbar = ({ activeTab, setActiveTab}) => {

  const navigate = useNavigate()

  const tabs = [
    { icon: TicketIcon, label: 'Ticket', path: '/tickets' },
    { icon: CalendarIcon, label: 'Calendar', path: '/' },
    { icon: UserIcon, label: 'User', path: '/profile' }
  ];

  return (
    <nav className="bottom-nav">
      <div className="nav-background"></div>
      
      {tabs.map((tab, index) => (
        <button
          key={tab.label}
          className={`nav-tab ${activeTab === index ? 'active' : ''}`}
          onClick={() => {
            setActiveTab(index)
            navigate(tab.path)
          }}
          aria-label={tab.label}
        >
          <span className="tab-content">
            <img 
              src={tab.icon} 
              alt={tab.label}
              className="tab-icon"
            />
            {/* <span className="tab-label">{tab.label}</span> */}
          </span>
        </button>
      ))}
      
      <div 
        className="active-highlight" 
        style={{ '--active-index': activeTab }}
      />
    </nav>
  );
};

export default BottomNavbar;